import React, { createContext, useContext, useEffect, useState } from "react";

/**
 * Blog ayarlarını (multilang_enabled, default_language, enabled_languages,
 * fallback_behavior, language_detection) backend'den çeker ve tüm blog
 * sayfalarına dağıtır.
 *
 * Backend default'u (multilang_enabled=0, default_language='tr') ile uyumlu
 * fallback'ler vardır — fetch başarısız olursa landing yine çalışır.
 */

const DEFAULT_SETTINGS = {
  multilang_enabled: false,
  default_language: "tr",
  enabled_languages: ["tr"],
  fallback_behavior: "default",
  language_detection: "url",
  loading: true,
  error: null,
};

const BlogContext = createContext(DEFAULT_SETTINGS);

export function BlogProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    let cancelled = false;
    fetch("/api/blog/settings")
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("HTTP " + r.status))))
      .then((data) => {
        if (cancelled) return;
        setSettings({
          multilang_enabled: !!data.multilang_enabled,
          default_language: data.default_language || "tr",
          enabled_languages: Array.isArray(data.enabled_languages) ? data.enabled_languages : ["tr"],
          fallback_behavior: data.fallback_behavior || "default",
          language_detection: data.language_detection || "url",
          loading: false,
          error: null,
        });
      })
      .catch((err) => {
        if (cancelled) return;
        setSettings({ ...DEFAULT_SETTINGS, loading: false, error: err.message });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return <BlogContext.Provider value={settings}>{children}</BlogContext.Provider>;
}

export function useBlogSettings() {
  return useContext(BlogContext);
}

/**
 * Blog için aktif dili belirler.
 *  - multilang_enabled=false → her zaman default (TR)
 *  - multilang_enabled=true  → URL'den gelen lang aktif dillerden biriyse onu, değilse default
 */
export function resolveBlogLang(uiLang, settings) {
  if (!settings || settings.loading) return uiLang || "tr";
  if (!settings.multilang_enabled) return settings.default_language;
  if (settings.enabled_languages.includes(uiLang)) return uiLang;
  return settings.default_language;
}
